export const SCROLLBAR_HEIGHT = 8;
